var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import styled from "styled-components";
import { Review, ReviewOverview } from "..";
var Container = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  color: ", ";\n  padding: 1rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  color: ", ";\n  padding: 1rem;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorContent();
});
var ReviewContainer = function (_a) {
    var image = _a.image, reviews = _a.reviews, title = _a.title;
    return (React.createElement(Container, null,
        React.createElement(ReviewOverview, { reviews: reviews, image: image, title: title }),
        reviews.map(function (review) { return React.createElement(Review, __assign({ key: review.id }, review)); })));
};
export default ReviewContainer;
var templateObject_1;
